/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Deleted_SuccessInputs */

const en_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP guide deleted successfully`)
};

const fr_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide KNP supprimé avec succès`)
};

const de_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Leitfaden erfolgreich gelöscht`)
};

const it_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida KNP eliminata con successo`)
};

const ru_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путеводитель по КНП успешно удален.`)
};

const es_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía KNP eliminada con éxito`)
};

const zh_cn2_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP 指南已成功删除`)
};

const ja_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNPガイドが正常に削除されました`)
};

const hi_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी गाइड सफलतापूर्वक हटा दी गई`)
};

const pt_pt2_knp_guide_deleted_success = /** @type {(inputs: Knp_Guide_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia do KNP excluído com sucesso`)
};

/**
* | output |
* | --- |
* | "KNP guide deleted successfully" |
*
* @param {Knp_Guide_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_deleted_success = /** @type {((inputs?: Knp_Guide_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_deleted_success(inputs)
	if (locale === "de") return de_knp_guide_deleted_success(inputs)
	if (locale === "it") return it_knp_guide_deleted_success(inputs)
	if (locale === "ru") return ru_knp_guide_deleted_success(inputs)
	if (locale === "es") return es_knp_guide_deleted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_deleted_success(inputs)
	if (locale === "ja") return ja_knp_guide_deleted_success(inputs)
	if (locale === "hi") return hi_knp_guide_deleted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_deleted_success(inputs)
	return en_knp_guide_deleted_success(inputs)
});